// Constants
import { DRAG_START, DRAG_END, FORCE_HOVER_EFFECT, CLEAR_HOVER_EFFECT } from './draggingConstants';

export const dragStart = ({ ids, source, finishEditing = true } = {}) => ({
    type: DRAG_START,
    ids,
    source,
    finishEditing,
});
export const dragEnd = (dropState) => ({ type: DRAG_END, dropState });
export const forceHoverEffect = (effect) => ({ type: FORCE_HOVER_EFFECT, effect });
export const clearHoverEffect = () => ({ type: CLEAR_HOVER_EFFECT });
